"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var ReachedCardWithTimer = function (_a) {
    var title = _a.title, disclaimer = _a.disclaimer, endDate = _a.endDate;
    var t = (0, next_intl_1.useTranslations)();
    var tDef = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var time = (0, common_hooks_1.useTimer)({ endDate: endDate }).time;
    var isGamePage = (0, apps_shared_1.useCheckPageUrl)('game');
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var closeGameHandler = (0, react_1.useCallback)(function () {
        if (isGamePage)
            router.push(generateUrlWithLang('/'));
        else
            closeModal();
    }, [router, generateUrlWithLang, closeModal, isGamePage]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "450px", height: "auto", padding: "0", onClose: closeGameHandler, showClose: false },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.disclaimer }, disclaimer),
                time && (react_1.default.createElement("div", { className: styles_module_scss_1.default.timeContainer },
                    react_1.default.createElement("div", null,
                        (time === null || time === void 0 ? void 0 : time.days) || 0,
                        react_1.default.createElement("span", null,
                            " ",
                            t('timer.days'),
                            " ")),
                    react_1.default.createElement("div", null, ":"),
                    react_1.default.createElement("div", null,
                        (time === null || time === void 0 ? void 0 : time.hours) || 0,
                        react_1.default.createElement("span", null,
                            " ",
                            t('timer.hours'),
                            " ")),
                    react_1.default.createElement("div", null, ":"),
                    react_1.default.createElement("div", null,
                        (time === null || time === void 0 ? void 0 : time.minutes) || 0,
                        react_1.default.createElement("span", null,
                            " ",
                            t('timer.minutes'),
                            " ")),
                    react_1.default.createElement("div", null, ":"),
                    react_1.default.createElement("div", null,
                        (time === null || time === void 0 ? void 0 : time.seconds) || 0,
                        react_1.default.createElement("span", null,
                            " ",
                            t('timer.seconds')))))),
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: closeGameHandler, maxWidth: "335px", width: "100%" }, tDef('ok')))));
};
exports.default = ReachedCardWithTimer;
